<template>
	<div class="container">
    <home-header class="header" :title="(topicInfo ||{title:'活动'}).topic_name"></home-header>
    <div class="list">
      <div class="product-list">
        <div class="product-list-header" @click="productListClick(topicInfo)">
          <span class="header-title">{{topicInfo.title}}</span>
        </div> 
        <div class="product-list-body">
          <img v-bind:style="getBannerStyle" v-if="topicInfo.photo" :src="topicInfo.photo" alt="" @click="productListClick(topicInfo)"  srcset="">
          <!-- 专题简介 -->
          <div class="product-list-intro" v-if="topicInfo.intro_url">
            <iframe sandbox="allow-scripts" frameborder="0" scrolling="no" id="iframe" ref="iframe" class="content-wrapper" @load="getIframeHeight" :src="getIntro"></iframe>
          </div>
          <!-- 导航栏 -->      
            <navbar v-if="topicAllProducts && topicAllProducts.length > 0 && topicAllProducts[0].name!=='default'" :navItems="topicAllProducts" @changeItem="setActiveItem" ></navbar>
          <!-- 商品列表 -->
          <topic-product-body v-for='(item, index) in (currentItemCategory||{}).data'  :item="item" :index="index" :cartAddType="cartAddType" :key='index'></topic-product-body>
        </div>
      </div>
    </div>
		<back-top v-if="isshowBacktop" :target="target" :bottom="60"></back-top>
	</div>
</template>
<script>
import { Header, Indicator, Toast } from 'mint-ui';
import BackTop from '../../components/common/BackTop';
import HomeHeader from './child/HomeHeader';
// import { recommendBonusInfo } from '../../api/recommend'

import Navbar from '../../components/common/Navbar';
import TopicProductBody from './child/TopicProductBody';
// import DOMPurify from 'dompurify';
import { topicProductList } from '../../api/topic'

export default {
  name: 'topic',
  data() {
    return {
      isshowBacktop: false,
      currentItemCategory: {},  // 当前选中的专题分类
      topicAllProducts:[],  // 专题的所有商品
      intro:null,
      topicInfo:{},  // 专题信息
      // 点击添加按钮‘+’后的逻辑：
      // 1：直接添加到购物车（不显示购买数量设置按钮）；
      // 2：直接添加到购物车（用于整行显示商品的列表来显示购买数量设置按钮，此处与不显示，与 1 相同）；
      // 3：点击后弹出购物车浮层，提示设置购买数量和规格
      cartAddType: 3
    };
  },
  components: {
    HomeHeader,
    BackTop,
    TopicProductBody,
    Navbar
  },
  created() {
    console.log("topic.vue/created/id="+this.$route.query.tid)
  },
  mounted() {      
    var element = this.$el;
    var that = this;
    var dom = document.querySelector('.list');    
    if (dom) {
      dom.addEventListener('scroll', event => {
        let params = {
          top: dom.scrollTop,
          height: dom.scrollHeight
        };
        if (params.top >= 100) {
          this.isshowBacktop = true;
        } else {
          this.isshowBacktop = false;
        }
      });
    }
    this.target = document.querySelector('.list');
    this.getTopicProduct()
  },
  activated(){
    this.target.addEventListener('scroll', (event) => {
      if (this.target.scrollTop) {
        this.offsetTop = this.target.scrollTop
      } 
    });
    if(this.offsetTop) this.target.scrollTop = this.offsetTop
  },
  computed: {
    getBannerStyle: function () {
      const { width, height } = window.screen
      let itemWidth = width
      let itemHeight = width * (74.0 / 188.0) //(94.0 / 188.0)
      return {
        width: itemWidth + 'px',
        height: itemHeight + 'px'
      }
    },
    getIntro: function() {
      return this.topicInfo.intro_url;
		}
  },
  methods: {
    getTopicProduct() {
      Indicator.open();
      let  id = this.$route.query.tid || null
      let  display_area = this.$route.query.display_area || 1
      let page = 1
      let per_page = 1000
      console.log("Topic.vue/getTopicProduct/id="+id)
      // 获取专题商品
      topicProductList(id, page, per_page, true).then(
        response => {
          if (response) {
            this.topicInfo = response.topic
            this.topicAllProducts = response.dataList || null
            // 初始化当前专题分类
            this.currentItemCategory = response.dataList[0] || null
            console.log("Topic.vue/getTopicProduct/topicInfo=")
            console.dir(this.topicInfo)
            console.log("Topic.vue/getTopicProduct/currentItemCategory=")
            console.dir(response.dataList[0])
            this.cartAddType = response.cart_add_type || 3;
          }
          Indicator.close()
        },
        error => {
          console.log(error)
          Indicator.close()
        }
      )
    },
    setIframHeight(event) {
      // if (event.origin === 'https://your-iframe-domain.com') { // 验证源  
        var contentHeight = event.data;  
        console.log('Iframe content height:', contentHeight);  
        console.log("event.origin = "+event.origin);
              
        if(contentHeight) iframe.style.height = `${contentHeight}px`;  // 32是iframe内部的margin-top(16)+margin-buttom(16)
        removeEventListener('message', this.setIframHeight);
      // }  
    },
    getIframeHeight() {
      console.log("topic.vue/getIframeHeight");
      const iframe = document.getElementById('iframe');

      window.addEventListener('message', this.setIframHeight);

      iframe.contentWindow.postMessage(
        'getHeight', 
        '*' // 替换为目标域的URL
      );
    },
		/*
		 * 设置当前选中的nav item
		 * @param: item 当前选中的item
		*/
		setActiveItem(item) {
      console.log("topic.vue/setActiveItem/currentItem="+item.name)
			this.currentItemCategory = item;
      console.log("topic.vue/setActiveItem/currentItemCategory=")
      console.dir(this.currentItemCategory)
      // this.$parent.$emit('change-list', this.currentItem);
		},
    productListClick: function(items) {
      let  id = this.$route.query.tid || null
      this.$router.push({
        name: 'topic',
        query: { tid: id ,display_area:1}
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: auto;
  position: absolute;
  bottom: 0px;
  top: 0px;
  width: 100%;
}
.header {
  background-color: #ffffff;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  border-bottom: 1px solid $lineColor;
}
// .header :nth-child(1) {
//   background-color: #ffffff;
//   position: fixed;
//   top: 0px;
//   left: 0px;
//   right: 0px;
//   border-bottom: 1px solid $lineColor;
// }
.list {
  background-color: #ffffff;
  padding-top:10px;
  position: absolute;
  top: 32px;
  bottom: 0px;
  overflow-y: auto;
  width: 100%;
}

.product-list {
  background: #FFFFFF;
  margin-top: 0px;
  margin-bottom: 12px;
  border-top: 2px #eeeeee solid;
  margin-bottom: 50px;
  .product-list-header {
    display: flex;
    height: 40px;
    padding: 0px 5px;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #F5F5F5;
    .header-title {
      margin-left: 10px;
      padding-left:10px;
      border-left: 2px #f17100 solid;
      font-size: 16px;
      line-height: 16px;
      color: #333333;
    }
    .header-icon {
      width: 20px;
      height: 20px;
    }
  }
  .product-list-intro {
    display: flex;
    // height: auto;
    // min-height: 10px;
    width: 100%;
    padding: 0px 5px;
    justify-content: space-between;
    align-items: center;
    .content-wrapper {
      border: none;
      width: 100%;
    }
  }

  .product-list-body {
    border: none;
    display: flex;
    flex-wrap: wrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/topic/topic.vue